export const SET_COMPANIES_DATA = 'SET_COMPANIES_DATA';

export const SET_MEMBERS_DATA = 'SET_MEMBERS_DATA';

export const SET_RELATED_PROPERTY_DATA = 'SET_RELATED_PROPERTY_DATA';
export const RESET_RELATED_PROPERTY_DATA = 'RESET_RELATED_PROPERTY_DATA';

export const SET_CUSTOM_FIELDS_DATA = 'SET_CUSTOM_FIELDS_DATA';
export const RESET_CUSTOM_FIELDS_DATA = 'RESET_CUSTOM_FIELDS_DATA';
